import { render, staticRenderFns } from "./UiToolbar.vue?vue&type=template&id=5b474ad9"
import script from "./UiToolbar.vue?vue&type=script&lang=js"
export * from "./UiToolbar.vue?vue&type=script&lang=js"
import style0 from "./UiToolbar.vue?vue&type=style&index=0&id=5b474ad9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports